
import { Fragment } from 'vue-fragment';
import Price from '@/components/helpers/Price';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import productCartMixin from '@/mixins/product-cart-mixin';
import FavoritesClearIcon from '@/components/svg/FavoritesClearIcon.vue';
import CompareIcon from '@/components/svg/CompareIcon.vue';
import BadgeDiscountIcon from '@/components/svg/BadgeDiscountIcon';
import BadgeNewIcon from '@/components/svg/BadgeNewIcon';
import imagePath from '@/mixins/imagePath';

export default {
    components: {
        CompareIcon,
        FavoritesClearIcon,
        Price,
        Fragment,
        BadgeDiscountIcon,
        BadgeNewIcon,
        FirstToKnow: () => import(`~/components/svg/FirstToKnow`),
        AddedToCartIcon: () => import(`~/components/svg/AddedToCartIcon`),
        CartIcon: () => import(`~/components/svg/CartIcon`),
        ClickIcon: () => import(`~/components/svg/ClickIcon`)
    },
    mixins: [productCartMixin, imagePath],
    props: {
        product: {
            type: Object,
            required: true
        },
        listDisplayType: {
            type: Boolean,
            default: () => false
        }
    },
    data() {
        return {
            userTheme: 'light_theme',
            isAddedToCart: false,
            swiper: null
        };
    },
    methods: {
        ...mapActions('cart', ['addProductToCart']),
        ...mapActions(['buyOneClickProduct', 'firstToKnowClick']),
        ...mapActions(['preorderProductClick']),
        buyOneClick(product) {
            this.buyOneClickProduct(product);
        },
        add(product) {
            this.addCart(product);
            if (this.isBtnCartCasa) {
                this.isAddedToCart = true;
                setTimeout(() => {
                    this.isAddedToCart = false;
                }, 1500);
            }
        }
    },
    computed: {
        ...mapGetters({
            globalSettings: 'global/globalSettings',
            isVitrina: 'global/isVitrina',
            creditsAvailable: 'global/creditsAvailable',
            isUnitsMeasuresAllow: 'global/isUnitsMeasuresAllow'
        }),
        getHidePriceForGuests() {
            console.log(this.$store?.state?.auth?.isAuth);
            return (
                this.$store?.state?.global?.globalSettings?.hide_price_for_guests &&
                !this.$store?.state?.auth?.isAuth &&
                !this.$store?.state?.auth?.isAuth
            );
        },
        isFirstToKnow() {
            return this.globalSettings?.additional_settings?.report_availability;
        },
        isBtnCartCasa() {
            return this.globalSettings?.mainUiInterface?.product_cart_button_view_type === 'casadeltabaco';
        }
    },
    mounted() {
        if (!this.userTheme) {
            this.userTheme = document.documentElement.classList.contains('light-theme') ? 'light_theme' : 'dark_theme';
        }

        if (this.product?.images?.length > 1 && this.isNovaPorta) {
            this.swiper = new Swiper(this.$refs.swiper, {
                currentImageIndex: 0,
                swiperOptions: {
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    slidesPerView: 1 // Show one image at a time
                },
                swiperModules: [Swiper.Navigation, Swiper.Pagination] // Import required modules
                // isFavorite: false, // Flag to track favorite state
            });
        }
    }
};
